module.exports = __webpack_public_path__ + "img/allow-left-blue.0995db5b.svg";